import { mainApi } from "../services/main/api";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        createArtifact: builder.mutation<CreateArtifactResponse, CreateArtifactRequest>({
            query: (request?: CreateArtifactRequest) => ({
                url: "createArtifact",
                body: request,
                method: "POST",
            }),
        }),
    }),
    overrideExisting: false,
});

export const { useCreateArtifactMutation } = extendedApi;

export interface CreateArtifactRequest {
    artifactType: string;
    businessUseCase: string;
    clientName: string;
    artifactDetails: {
        commentedBy: string;
        text: string;
        associatedArtifactType: string;
        associatedArtifactId: string;
    };
}

export interface CreateArtifactResponse {
    artifactId: string;
}
